import Skeleton from "@/app/components/ui-elements/skeleton";

export default function LoadingStaff() {
  return (
    <main className="p-8 w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(12)].map((_, i) => (
          <div key={i} className="space-y-4">
            <Skeleton className="aspect-video h-[250px] w-full" />
          </div>
        ))}
      </div>
    </main>
  );
}